import { Avatar, Box, Typography } from "@mui/material";
import styled from "@emotion/styled";

interface IProps {
  message: {
    attachment?: string;
    isMine: boolean;
    message: string;
    message_id: number;
    sent_time: string;
    user_avatar: string;
    user_name: string;
  };
  displayAvatar: boolean;
}

const ImageAttachment = styled("img")({
  borderRadius: "4px",
  objectFit: "cover",
  maxWidth: "300px",
  maxHeight: "200px",
});

export default function Message({ message, displayAvatar }: IProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: `flex-start`,
        gap: 1,
        direction: message.isMine ? "rtl" : "ltr",
        wordBreak: "break-all",
      }}
    >
      {displayAvatar && (
        <Avatar
          sx={{
            width: "30px",
            height: "30px",
          }}
          alt={message.user_name}
          src={message.user_avatar}
        />
      )}
      <Box
        sx={{
          paddingInlineStart: displayAvatar ? "" : "2.3rem",
        }}
      >
        {displayAvatar && (
          <Typography sx={{ fontSize: "11px", margin: 0 }} variant="subtitle1">
            {message.user_name}
          </Typography>
        )}
        <Typography
          sx={{
            p: 1,
            backgroundColor: "#f3f3f3",
            borderRadius: "8px",
            fontSize: "12px",
            direction: "ltr",
          }}
          variant="subtitle1"
        >
          {message.message}
          <Box>
            {message.attachment && (
              <ImageAttachment
                src={message.attachment}
                alt="attachment"
                onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
                  event.currentTarget.src = require("../../../assets/no-image.png");
                }}
              />
            )}
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
